import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from './../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	pattern_email, 
	passwordHash,
	//set_darkmode,

} from '../../../Utils';

import { language } from './Language';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, set_is_password] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [disabled, set_disabled] = useState(true)
	const [/*is_input_disabled*/, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				//console.log(getTokenInfo().profile)

				if(res.data[0].profile.name === 'Administrador') {
					if(getTokenInfo().profile === 'Administrador'){
						set_dados(dados.current = res.data[0]);
					}else{
						setRedirect(true);
					}
				}
				else{
					set_dados(dados.current = res.data[0]);
				}

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_input_disabled(false)
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPUT(api_crud_route, dados.current)
						.then(() => {
							set_new_password('')
							set_confirm_password('')
							
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					if(is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPOST(api_crud_route, dados.current)
						.then(() => { 
							set_new_password('')
							set_confirm_password('')
							
							props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	const handleSubmitConfig = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					let password = dados.current.info.password;
					dados.current.info.password = passwordHash(password);

					reqPOST(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqPUT(api_crud_route, dados.current)
					.then(() => { props.history.push(endpoints.list) })
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
			}
		})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(res => {
						props.history.push(endpoints.list);
					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};

	const load_entity = async (field, value, entity) => {
		let search_string = ''

		if (entity === '') {
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`
		}
		else
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`

		reqGET(search_string)
			.then(res => {
				console.log(res.data)

				let ja_existe = false
				res.data.forEach((k) => {
					if (k[field] === value && value !== '') {

						ja_existe = true
					}
				})

				if (ja_existe === false) {
					set_is_input_disabled(true)

					if (field === 'username') {
						set_is_input_disabled(false)
					}
					return

				} else {
					//set_disabled(true)

					Swal.fire({
						title: language[lang].warning_title,
						text: language[lang].warning_text,
						icon: 'warning',
						showCancelButton: false,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].warning_confirm,
						cancelButtonText: language[lang].warning_cancel
					})
					.then((result) => {
						if (result.isConfirmed) {
							set_is_input_disabled(true)
							//set_disabled(false)
							document.getElementById('username').style.color = 'red';
						}
					})

				}
			})
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if(new_password === value) {
			set_is_password(true)
			//set_disabled(false)
		}
		else {
			Swal.fire(language[lang].password_text, '', 'info')
			set_is_password(false)
			//set_disabled(true)
		}
	}
	
	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		if(name === 'email') {
			set_dados(dados.current.info[name] = value)
		}

		set_dados(dados.current.contacts[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handleSingleCheckDarkmode = (e) => {
		if(dados.current.info['darkmode'] === true) {
			set_dados(dados.current.info['darkmode'] = false)
			//set_darkmode(false)
		}
		else {
			set_dados(dados.current.info['darkmode'] = true)
			//set_darkmode(true)
		}

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / { dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new }</p>
				</div>
		
				<div className={`dash-cards body`}>
					<div className="container">
		
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_info">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div_entidade_info" className="collapse show">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className="row">
													<div className="col-12 col-sm-8 mb-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].name}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-12 col-sm-4 mb-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].organization}</label>
														<input type="text" name="organization" value={dados.current.info.organization} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].organization_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-6 col-sm-4 mb-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].email}</label>
														<input type="email" pattern={pattern_email} name="email" value={dados.current.contacts[0].email} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_contacts} />
													</div>

													<div className="col-6 col-sm-4 mb-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].phone}</label>
														<input type="tel" name="phone" value={dados.current.contacts[0].phone} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].phone_placeholder} onChange={handle_change_contacts} />
													</div>

													<div className="col-6 col-sm-4 mb-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].mobile_phone}</label>
														<input type="tel" name="mobile_phone" value={dados.current.contacts[0].mobile_phone} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].mobile_phone_placeholder} onChange={handle_change_contacts} />
													</div>

												</div>
											</div>
										</form>
									</div>
								</div>

								{
								false ?
									<div className="card mt-5">
										<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
											</div>
										</div>
										<div id="div_entidade_password" className="collapse show">
											<form id="form_pass" onSubmit={handleSubmitPassword}>

												<div className="card-body border-top p-4">

													<div className="row mb-6">
														<div className="col-md-4 fv-row">
															<label className="fs-6 fw-bold mb-2">{language[lang].username}</label>
															<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} required />
														</div>
														<div className="col-md-4 fv-row">
															<label className="fs-6 fw-bold mb-2">{language[lang].password}</label>
															<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
														</div>
														<div className="col-md-4 fv-row">
															<label className="fs-6 fw-bold mb-2">{language[lang].password_confirmation}</label>
															<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
														</div>
													</div>

													<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
														<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
															<span>{language[lang].cancel}</span>
														</Link>

														<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
															<span>{language[lang].delete}</span>
														</button>

														<button type="submit" form="form_pass" className="btn btn-primary">
															<span>{language[lang].save}</span>
														</button>
													</div>
												</div>
											</form>
										</div>
									</div>
								:
									null
								}
							</div>

							<div className="col-md-4 mb-5 mb-xl-10 d-none">
								<div className="card">
									<div className="card-header border-0" aria-expanded="true" aria-controls="kt_entidade_config">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].config}</h3>
										</div>
									</div>
									<div id="kt_entidade_config" className="collapse show">
										<form id="form-config" onSubmit={handleSubmitConfig}>

											<div className="card-body border-top p-3">

												<div className="row mb-6">
													<label className="fs-6 fw-bold mb-2">{language[lang].language}</label>
													
													<select className="form-select mb-3 mb-lg-0 rounded-0" aria-label="Select Language" name='language' defaultValue={dados.current.info.language} onChange={handle_change_info}>
														<option value="pt">PT</option>
														<option value="en">EN</option>
													</select>
												</div>

												<div className="row mb-6">
													<label className="form-check form-switch form-check-custom form-check-solid pulse pulse-success" htmlFor="kt_user_menu_dark_mode_toggle">
														<input
															id={'dark-mode-switch'}
															name="darkmode"
															className="form-check-input w-45px h-30px"
															type="checkbox"
															onChange={handleSingleCheckDarkmode}
															defaultChecked={dados.current.info.darkmode}
														/>
														<span className="pulse-ring ms-n1"></span>
														<span className="form-check-label text-gray-600 fs-7">Dark Mode</span>
													</label>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								{ getTokenInfo().profile !== 'Gestor de Conteúdos' ? (
									<li className="nav-item">
										<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
										</Link>
									</li>
								):null}
								{ getTokenInfo().profile !== 'Gestor de Conteúdos' ? (
									<li className={"nav-item " + show_delete_button}>
										<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
											<i className="bi bi-trash3 me-2"></i>
											<span>{language[lang].delete}</span>
										</button>
									</li>
								):null}
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
